
/**
* Components are lazy-loaded - See "Grouping Components in the Same Chunk"
* http://router.vuejs.org/en/advanced/lazy-loading.html
*/
/* eslint-disable global-require */
const Dashboard = r => require.ensure([], () => r(require('./main')), 'dashboard-bundle')
const AddDomain = r => require.ensure([], () => r(require('./add-domain')), 'dashboard-bundle')
const Stats = r => require.ensure([], () => r(require('./stats')), 'dashboard-bundle');

const gsuite = {
  reported_mails: r => require.ensure([], () => r(require('../gsuite/components/reported_mails/index')),  'gsuite-bundle'),
};

export default [
  // {
  //   name: 'dashboard.index',
  //   path: '/',
  //   component: Dashboard,
  //   meta: { requiresAuth: true },
  // },
  {
    name: 'dashboard',
    path: '/dashboard',
    component: Dashboard,
    meta: { requiresAuth: true, title: "Dashboard | Email Remediator" },
  },
  {
    name: 'stats',
    path: '/stats/:type',
    component: Stats,
    meta: { requiresAuth: true },
    props: true
  },
  {
    name: 'dashboard.index',
    path: '/',
    component: gsuite.reported_mails,
    meta: { requiresAuth: true },
  },
  {
    name: 'dashboard.add-domain',
    path: '/add-domain',
    component: AddDomain,
    meta: { requiresAuth: true },
  },
  {
    name: 'catchall',
    path: '*',
    component: Dashboard,
    meta: { requiresAuth: true },
  },
]



// WEBPACK FOOTER //
// ./src/app/dashboard/routes.js